import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { Box, Snackbar, Alert, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getUser, updateProfile } from '../Redux/Auth/Action';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

const Profile = () => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [profileData, setProfileData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        password: ''
    });

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const jwt = localStorage.getItem('jwt');

    const { auth } = useSelector((store) => store);

    useEffect(() => {
        if (jwt) {
            dispatch(getUser(jwt));
        }
    }, [jwt, dispatch]);

    useEffect(() => {
        if (auth.user) {
            setProfileData({
                firstName: auth.user.firstName,
                lastName: auth.user.lastName,
                email: auth.user.email,
                mobile: auth.user.mobile || '', // Populate phone number if available
                password: ''
            });
        }
    }, [auth.user]);

    const handleClose = () => setOpenSnackBar(false);

    // Effect to show Snackbar if there's a success or error message
    useEffect(() => {
        if (auth.updateSuccess || auth.error) setOpenSnackBar(true);
    }, [auth.updateSuccess, auth.error]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const updatedData = {
            firstName: data.get('firstName'),
            lastName: data.get('lastName'),
            email: data.get('email'),
            mobile: data.get('mobile'),
            password: data.get('password') || undefined
        };

        dispatch(updateProfile(jwt, updatedData));
    };

    useEffect(() => {
        if (!auth.user) {
            navigate('/home');
        }
    }, [auth.user, navigate]);

    return (
        <>
            <Navbar />
            <div className='flex flex-col justify-center items-center min-h-screen bg-black text-gray-200 pt-32 pb-5 px-3'>
                <div className="w-full max-w-lg md:max-w-md lg:max-w-sm p-6 bg-[#1a1a1a] rounded-lg border border-gray-600 mx-4">
                    <button
                        onClick={() => window.history.back()}
                        className="text-gray-400 border border-gray-400 py-2 px-4 rounded-lg mb-6 hover:bg-[#333] transition text-sm">
                        ← Back
                    </button>
                    <h1 className="text-2xl md:text-3xl font-semibold text-white mb-4">Edit Profile</h1>

                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label htmlFor="firstName" className="block text-sm font-medium mb-1 text-gray-300">
                                First Name*
                            </label>
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                value={profileData.firstName}
                                onChange={(e) => setProfileData({ ...profileData, firstName: e.target.value })}
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                                required
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="lastName" className="block text-sm font-medium mb-1 text-gray-300">
                                Last Name*
                            </label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                value={profileData.lastName}
                                onChange={(e) => setProfileData({ ...profileData, lastName: e.target.value })}
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                                required
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="email" className="block text-sm font-medium mb-1 text-gray-300">
                                Email*
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={profileData.email}
                                onChange={(e) => setProfileData({ ...profileData, email: e.target.value })}
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                                required
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="mobile" className="block text-sm font-medium mb-1 text-gray-300">
                                Phone Number
                            </label>
                            <input
                                type="tel"
                                id="mobile"
                                name="mobile"
                                value={profileData.mobile}
                                onChange={(e) => setProfileData({ ...profileData, mobile: e.target.value })}
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                                placeholder="123-456-7890"
                            />
                        </div>

                        <div className="mb-4 relative">
                            <label htmlFor="password" className="block text-sm font-medium mb-1 text-gray-300">
                                New Password (Optional)
                            </label>
                            <input
                                type={passwordVisible ? 'text' : 'password'}
                                id="password"
                                name="password"
                                placeholder="New Password"
                                value={profileData.password}
                                onChange={(e) => setProfileData({ ...profileData, password: e.target.value })}
                                className="w-full px-4 py-2 bg-[#333] rounded-md text-gray-100 focus:outline-none focus:ring focus:ring-gray-500"
                            />
                            <span
                                onClick={() => setPasswordVisible(!passwordVisible)}
                                className="absolute right-3 top-8 cursor-pointer text-gray-400"
                            >
                                {passwordVisible ? '🙈' : '👁'}
                            </span>
                        </div>

                        <p className="text-gray-500 text-xs text-center mb-1">
                            Fields marked with * are required
                        </p>

                        <button
                            type="submit"
                            className="w-full py-2 bg-white text-black rounded-md hover:bg-gray-200 transition"
                        >
                            Save Changes
                        </button>
                    </form>
                </div>

                <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={auth.error ? 'error' : 'success'} sx={{ width: '100%' }}>
                        {auth.error ? auth.error : auth.updateSuccess ? 'Profile Updated Successfully' : ''}
                    </Alert>
                </Snackbar>
            </div>
            <Footer />
        </>
    );
};

export default Profile;
